module.exports = __webpack_public_path__ + "static/screenshot2-93102c19dbd0e9ae99a610142d8972d2.png";